export default __webpack_public_path__ + "static/media/joingame2.703394c2.png";